var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Vue, Component, Watch } from "vue-facing-decorator";
import { Feature, CompaniesClient, SystemsClient, SitesClient, SystemComponentsClient, MaintenanceLogsClient, LookupsClient, CreateMaintenanceLogCommand, UpdateMaintenanceLogCommand, MaintenanceLogModel, SystemAccessQueryModel, SystemComponentQueryModel, AlarmSeverityEnum } from "@/app/api/battery-portal-api";
import { Notifier } from "@/common/utils/notifier";
import { Alert } from "@/common/utils/alert";
import { HttpHelper } from "@/app/utils/http-helper";
import { MeasurementHelper } from "@/app/utils/measurement-helper";
import { TextHelper } from "@/app/utils/text-helper";
import { DateHelper } from "@/app/utils/date-helper";
import { ArrayHelper } from "@/app/utils/array-helper";
import RouteNames from "@/app/router/routes";
import { useForm } from 'vee-validate';
import * as yup from 'yup';
const systemsClient = new SystemsClient(window.apiUrl);
const companyClient = new CompaniesClient(window.apiUrl);
const componentsClient = new SystemComponentsClient(window.apiUrl);
const maintenanceClient = new MaintenanceLogsClient(window.apiUrl);
const lookupClient = new LookupsClient(window.apiUrl);
const siteClient = new SitesClient(window.apiUrl);
let MaintenanceLogVue = class MaintenanceLogVue extends Vue {
    constructor() {
        super(...arguments);
        // components
        this.datePickerConfig = DateHelper.GetDefaultDatePickerConfig(true);
        // simpletons
        this.logId = 0;
        this.loaded = false;
        this.working = false;
        this.attemptedSave = false;
        this.alarmDetailsVisible = true;
        // models
        this.companyId = null;
        this.siteId = null;
        this.systemId = null;
        this.componentId = null;
        this.originalSystemId = 0;
        this.log = new MaintenanceLogModel();
        // arrays
        this.systems = new Array();
        this.systemComponents = new Array();
        this.logTypes = new Array();
        this.companies = [];
        this.sites = [];
        // components
        this.msg = new Alert();
        this.maxCommentLength = 5000;
    }
    created() {
        this.logId = parseInt(this.$route.params.id) || 0;
        this.getData();
    }
    ;
    mounted() {
    }
    ;
    // get
    load() {
        this.getData();
    }
    ;
    getLog() {
        if (this.isNewLog) {
            let log = new MaintenanceLogModel();
            log.init({
                whenEntered: new Date()
            });
            this.map(log);
            this.loaded = true;
            return;
        }
        ;
        return maintenanceClient
            .get(this.logId)
            .then(response => {
            if (!response) {
                this.$router.push({ name: RouteNames.Home });
                return;
            }
            this.map(response);
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    getData() {
        let promises = [
            this.getMaintenanceLogTypes(),
            this.getCompanies(),
            this.getSites(),
            this.getSystems()
        ];
        Promise
            .all(promises)
            .then(() => {
            this.getLog();
        }).catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    getMaintenanceLogTypes() {
        lookupClient
            .getMaintenanceLogTypes()
            .then(response => {
            this.logTypes = response;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    getCompanies() {
        return companyClient
            .getListGET()
            .then(response => {
            this.companies = response;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    getSites() {
        return siteClient
            .getListForUser()
            .then(response => {
            let options = response;
            this.sites = options;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    getSystems() {
        return systemsClient
            .getSystems(false, Feature.Comments_View)
            .then(response => {
            if (!response)
                return;
            this.systems = response;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    getSystemComponents() {
        if (!this.systemId)
            return;
        componentsClient
            .getSystemComponents(this.systemId)
            .then(response => {
            let systemComponents = response;
            // determine if device is no longer available in this system.
            if (this.log.componentId && this.originalSystemId == this.systemId) {
                let idx = ArrayHelper.findFirstIndex(systemComponents, (item) => {
                    return item.componentId == this.log.componentId;
                });
                if (idx < 0) {
                    let systemComponent = new SystemComponentQueryModel();
                    systemComponent.init({});
                    systemComponent.componentId = this.log.componentId;
                    systemComponent.componentName = `Archived device # ${this.log.componentId}`;
                    systemComponent.displayName = systemComponent.componentName;
                    systemComponents.unshift(systemComponent);
                }
            }
            else {
                this.log.componentId = null;
            }
            this.systemComponents = systemComponents;
            this.originalSystemId = this.systemId || 0;
        })
            .catch(ex => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        });
    }
    ;
    map(log) {
        this.originalSystemId = log.systemId;
        this.systemId = log.systemId;
        this.componentId = log.componentId || null;
        if (log.systemId) {
            let idx = ArrayHelper.findFirstIndex(this.systems, (item) => {
                return item.systemId == this.log.systemId;
            });
            if (idx < 0) {
                let system = new SystemAccessQueryModel();
                system.init({});
                system.systemId = this.log.systemId;
                system.systemName = `Archived system # ${this.log.systemId}`;
                this.systems.unshift(system);
            }
        }
        ;
        let system = this.systems.filter(system => system.systemId == log.systemId)[0];
        if (system) {
            this.companyId = system.companyId;
            this.siteId = system.siteId;
        }
        this.log = log;
        this.loaded = true;
    }
    ;
    // set
    save() {
        if (this.working)
            return;
        this.attemptedSave = true;
        this.setValues({
            system: this.system,
            type: this.logType,
            date: this.log.whenEntered,
            comment: this.log.notes
        });
        const handleSubmitAction = this.handleSubmit(() => {
            this.working = true;
            let log = this.log;
            log.whenEntered = DateHelper.convertToDate(log.whenEntered.toString());
            let promise = () => {
                return this.isNewLog
                    ? maintenanceClient.add(new CreateMaintenanceLogCommand({ requestModel: this.log }))
                    : maintenanceClient.update(this.log.logId, new UpdateMaintenanceLogCommand({ requestModel: this.log }));
            };
            promise()
                .then(logId => {
                this.logId = logId;
                this.log.logId = logId;
                Notifier.onOk();
                this.getLog();
            })
                .catch(ex => {
                HttpHelper.handleResponse(ex, () => {
                    Notifier.onServerError(ex);
                });
            })
                .finally(() => {
                this.working = false;
            });
        }, () => {
            Notifier.onError("Please check that you have entered all details correctly.");
        });
        handleSubmitAction();
    }
    ;
    archive() {
        if (this.working)
            return;
        if (this.isNewLog)
            return;
        this.working = true;
        maintenanceClient
            .delete(this.log.logId)
            .then(() => {
            this.log.whenDeleted = new Date();
            Notifier.onOk(`Log # ${this.log.logId} has been successfully archived.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    restore() {
        if (this.working)
            return;
        if (this.isNewLog)
            return;
        this.working = true;
        maintenanceClient
            .restore(this.log.logId)
            .then(() => {
            this.log.whenDeleted = undefined;
            Notifier.onOk(`Log # ${this.log.logId} has been successfully restored.`);
        })
            .catch((ex) => {
            HttpHelper.handleResponse(ex, () => {
                Notifier.onServerError(ex);
            });
        })
            .finally(() => {
            this.working = false;
        });
    }
    ;
    goBack() {
        this.$router.back();
    }
    ;
    get pageTitle() {
        return this.isNewLog ? "New Comment" : this.logTitle;
    }
    ;
    get logTitle() {
        if (!this.log)
            return "";
        return TextHelper.getRecordTitle(`Comment # ${this.log.logId || ""}`, this.isLogArchived);
    }
    ;
    get logTypesVisible() {
        if (this.logTypeId > 2)
            return this.logTypes.filter(item => item.logTypeId == this.logTypeId);
        return this.logTypes.filter(item => item.logTypeId <= 2);
    }
    // computed
    get isNewLog() {
        return !this.logId;
    }
    ;
    get isLogArchived() {
        return this.log.whenDeleted != null ? true : false;
    }
    ;
    get system() {
        return this.systems.filter(item => {
            return item.systemId == this.systemId;
        })[0] || null;
    }
    ;
    set system(item) {
        if (!item)
            return;
        this.systemId = item === null || item === void 0 ? void 0 : item.systemId;
        if (!this.systemId)
            return;
        this.log.systemId = item.systemId;
    }
    ;
    get component() {
        return this.systemComponents.filter(item => {
            return item.componentId == this.componentId;
        })[0];
    }
    ;
    set component(item) {
        if (!item)
            return;
        this.componentId = item === null || item === void 0 ? void 0 : item.componentId;
        if (!this.componentId)
            return;
        this.log.componentId = item.componentId;
    }
    ;
    get logTypeId() {
        return this.log.logTypeId;
    }
    ;
    get logType() {
        return this.logTypes.filter(item => {
            return item.logTypeId == this.logTypeId;
        })[0];
    }
    ;
    set logType(item) {
        if (!item)
            return;
        this.log.logTypeId = item.logTypeId;
    }
    ;
    get company() {
        return this.companies.filter(item => {
            return item.companyId == this.companyId;
        })[0];
    }
    ;
    set company(item) {
        var _a, _b;
        if (!item)
            return;
        this.companyId = item === null || item === void 0 ? void 0 : item.companyId;
        if (((_a = this.site) === null || _a === void 0 ? void 0 : _a.companyId) != this.companyId)
            this.siteId = null;
        if (((_b = this.system) === null || _b === void 0 ? void 0 : _b.companyId) != this.companyId) {
            this.systemId = null;
            this.componentId = null;
        }
        if (!this.system)
            return;
        this.system.companyId = item.companyId;
    }
    ;
    get site() {
        return this.sites.filter(item => {
            return item.siteId == this.siteId;
        })[0];
    }
    ;
    set site(item) {
        var _a;
        if (!item)
            return;
        this.siteId = item === null || item === void 0 ? void 0 : item.siteId;
        if (((_a = this.system) === null || _a === void 0 ? void 0 : _a.siteId) != this.siteId) {
            this.systemId = null;
            this.componentId = null;
        }
        if (!this.system)
            return;
        this.system.siteId = item.siteId;
    }
    ;
    get visibleSites() {
        let sites = this.sites;
        if (this.companyId)
            sites = sites.filter(site => site.companyId == this.companyId);
        return sites;
    }
    ;
    get visibleSystems() {
        let systems = this.systems;
        if (this.companyId)
            systems = systems.filter(system => system.companyId == this.companyId);
        if (this.siteId)
            systems = systems.filter(system => system.siteId == this.siteId);
        return systems;
    }
    ;
    get getCommentLength() {
        return this.log.notes ? this.log.notes.length : 0;
    }
    get hasNoSystems() {
        return this.isNewLog && this.visibleSystems.length === 0;
    }
    alarmClass(alarm) {
        if (alarm.alarmSeverityId == null)
            return "";
        if (alarm.alarmSeverityId == AlarmSeverityEnum.Critical)
            return "critical";
        if (alarm.alarmSeverityId == AlarmSeverityEnum.Warning)
            return "warning";
        if (alarm.alarmSeverityId == AlarmSeverityEnum.Info)
            return "info";
        return "";
    }
    ;
    getAlarmState(alarm) {
        return alarm.whenCleared ? "Inactive" : "Active";
    }
    ;
    getAlarmValue(alarm) {
        var output = this.getValue(alarm.extremeValue == undefined ? null : alarm.extremeValue, alarm.digits || 2);
        if (alarm.uoM) {
            output += " " + alarm.uoM;
        }
        return output;
    }
    getValue(value, digits = 2) {
        return MeasurementHelper.getRoundedValueString(value, digits);
    }
    ;
    get divAlarmsVisible() {
        var _a, _b;
        return (((_b = (_a = this.log) === null || _a === void 0 ? void 0 : _a.alarms) === null || _b === void 0 ? void 0 : _b.length) || 0) > 0;
    }
    getActiveAlarmsCount() {
        var _a;
        if (!((_a = this.log) === null || _a === void 0 ? void 0 : _a.alarms))
            return 0;
        return this.log.alarms.filter(item => item.whenCleared == null).length;
    }
    getTotalAlarmsCount() {
        var _a;
        if (!((_a = this.log) === null || _a === void 0 ? void 0 : _a.alarms))
            return 0;
        return this.log.alarms.length;
    }
    formatDateTime(dateTime) {
        return DateHelper.convertToFriendlyMomentTimeString(dateTime);
    }
    ;
    get divEventVisible() {
        var _a, _b;
        return (_b = (_a = this.log) === null || _a === void 0 ? void 0 : _a.event) !== null && _b !== void 0 ? _b : false;
    }
};
__decorate([
    Watch("systemId"),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", []),
    __metadata("design:returntype", void 0)
], MaintenanceLogVue.prototype, "getSystemComponents", null);
MaintenanceLogVue = __decorate([
    Component({
        name: "MaintenanceLogVue",
        setup() {
            const { errors, handleSubmit, defineInputBinds, defineComponentBinds, setValues } = useForm({
                validationSchema: yup.object({
                    system: yup.object().required(),
                    type: yup.object().required(),
                    date: yup.date().required(),
                    comment: yup.string().trim().required(),
                }),
            });
            const systemVal = defineComponentBinds('system');
            const typeVal = defineComponentBinds('type');
            const dateVal = defineInputBinds('date');
            const commentVal = defineInputBinds('comment');
            return {
                errors,
                handleSubmit,
                setValues,
                systemVal,
                typeVal,
                dateVal,
                commentVal
            };
        }
    })
], MaintenanceLogVue);
export default MaintenanceLogVue;
